
const BaseUrlProd = "https://döner-sonntag.de/api"
const BaseUrlTest = "http://192.168.0.34:5000"
//BaseUrl = BaseUrlProd
const BaseUrl =BaseUrlProd
const stage="Test"



const config = {
    BaseUrl: BaseUrl,
    Stage: stage
};

export default config;